module.exports = __webpack_public_path__ + "img/top-left-blop-mobile.f6508865.svg";